import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SocialShareService } from '@app/shared/services/social-share/social-share.service';
import { Product } from '@vestiaire/api-sdk-angular';
import { ImagesService } from '@app/shared/components/images/services/images.service';

@Component({
  selector: 'vc-product-share',
  templateUrl: './product-share.component.html',
  styleUrls: ['./product-share.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductShareComponent implements OnInit {
  @Input()
  product: Product;

  public shareLinks: {
    twitter: string;
    facebook: string;
    tumblr: string;
    pinterest: string;
    google: string;
  };
  public imgPath: string;

  constructor(private socialShareService: SocialShareService) {}

  ngOnInit() {
    this.setShareLinks();
    this.imgPath = ImagesService.buildUrl('/produit/' + this.product.pictures[0]['path']);
  }

  setShareLinks() {
    this.shareLinks = this.socialShareService.getAllShareLink(this.imgPath, this.product.description);
  }
}
